<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }}
        Driver
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- NAME -->
        <vs-input
          label="First Name"
          v-model="FirstName"
          class="mt-5 w-full"
          name="first-name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('first-name')">{{
          errors.first("first-name")
        }}</span>

        <!-- LAST NAME -->
        <vs-input
          label="Last Name"
          v-model="LastName"
          class="mt-5 w-full"
          name="last-name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('last-name')">{{
          errors.first("last-name")
        }}</span>

        <vs-input
          label="Driver ID"
          v-model="driverId"
          class="mt-5 w-full"
          v-validate="'required'"
          name="driverid"
        />
        <span class="text-danger text-sm" v-show="errors.has('driverid')">{{
          errors.first("driverid")
        }}</span>

        <!-- Username NAME -->
        <vs-input
          label="Username"
          v-model="UserName"
          class="mt-5 w-full"
          name="username"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('username')">{{
          errors.first("username")
        }}</span>
        <GooglePlacesAutocomplete @place-selected="handlePlaceSelected" />
        <span class="text-danger text-sm" v-show="errors.has('address1')">{{
          errors.first("address1")
        }}</span>
        <vs-input
          label="Address 2"
          v-model="address2"
          class="mt-5 w-full"
          name="address2"
        />
        <!-- v-validate="'required'"
        <span class="text-danger text-sm" v-show="errors.has('address2')">{{
          errors.first("address2")
        }}</span> -->
        <vs-input
          label="City"
          v-model="city"
          class="mt-5 w-full"
          name="city"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('city')">{{
          errors.first("city")
        }}</span>
        <vs-input
          label="State"
          v-model="state"
          class="mt-5 w-full"
          name="state"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('state')">{{
          errors.first("state")
        }}</span>
        <vs-input
          label="Zip"
          v-model="zip"
          class="mt-5 w-full"
          name="zip"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('zip')">{{
          errors.first("zip")
        }}</span>
        <!-- Password-->
        <div v-if="Object.entries(this.data).length === 0">
          <vs-input
            ref="password"
            type="password"
            data-vv-validate-on="blur"
            v-validate="'required|min:6'"
            name="password1"
            label="Password"
            v-model="password"
            class="w-full mt-6"
          />
          <span class="text-danger text-sm" v-show="errors.has('password1')">{{
            errors.first("password1")
          }}</span>
        </div>
        <div v-else>
          <vs-input
            ref="password"
            type="password"
            data-vv-validate-on="blur"
            v-validate="'min:6'"
            name="password"
            label="Password"
            v-model="password"
            class="w-full mt-6"
          />
          <span class="text-danger text-sm" v-show="errors.has('password')">{{
            errors.first("password")
          }}</span>
        </div>
        <!-- Email -->
        <vs-input
          type="email"
          label="Email"
          v-model="email"
          class="w-full"
          name="email"
          v-validate="'required|email'"
        />
        <span class="text-danger">{{ errors.first("email") }}</span>
        <!-- Phone -->
        <vs-input
          label="Phone number"
          v-model="Phone"
          class="w-full mt-4"
          type="tel"
          name="telefon"
          v-validate="'required'"
        />
        <span class="text-danger">{{ errors.first("telefon") }}</span>
        <!-- Driver's License  -->
        <vs-input
          label="Driver's License number"
          v-model="licence"
          class="w-full mt-4"
          type="tel"
          name="licence"
          v-validate="'required'"
        />
        <span class="text-danger">{{ errors.first("licence") }}</span>
        <!-- Province -->
        <div class="mt-5">
          <label class="text-sm"
            >Driver's License Issuing State/Province *
          </label>
          <v-select
            v-model="Province"
            class="mt-1 w-full"
            name="province"
            label="text"
            :options="licence1"
            v-validate="'required'"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('province')">{{
            errors.first("province")
          }}</span>
        </div>
        <!-- Home Terminal Address -->
        <!-- <div class="mt-5">
           <label class="text-sm">Home Terminal Address </label>
          <vs-input
            v-model="tadress"
            label="Home Terminal Address"
            disabled
            class="mt-1 w-full"
          >
          </vs-input>
        </div> -->
        <!-- <div class="mt-5">
          <label class="text-sm">Home Terminal Time Zone </label>
          <v-select
            v-model="ttime"
            label="text"
            name="zone"
            class="mt-1 w-full"
            v-validate="'required'"
            :options="timeOptions"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('zone')">{{
            errors.first("zone")
          }}</span>
        </div> -->
        <!-- Co-Driver -->
        <div class="mt-5">
          <label class="text-sm">Co-Driver </label>
          <v-select
            v-model="codriver"
            class="mt-1 w-full"
            label="name"
            :options="[{ name: 'none', id: null }, ...coDrivers]"
          >
          </v-select>
        </div>
        <!-- Vehicle ID-->
        <div class="mt-5">
          <label class="text-sm">Vehicle ID </label>
          <v-select
            v-model="vehicleid"
            name="vehicleid"
            class="mt-1 w-full"
            label="text"
            v-validate="'required'"
            :options="aviable"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('vehicleid')">{{
            errors.first("vehicleid")
          }}</span>
        </div>
        <div class="mt-5">
          <label class="text-sm">Color </label>
          <v-select
            v-model="color"
            name="color"
            class="mt-1 w-full"
            label="text"
            v-validate="'required'"
            :options="colors"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('color')">{{
            errors.first("color")
          }}</span>
        </div>
        <!-- Trailer No -->
        <!-- <vs-input label="Trailer No" v-model="TrailerNo" class="mt-5 w-full" /> -->
        <!-- Notes -->
        <vs-input label="Notes" v-model="Notes" class="mt-5 w-full" />
        <!-- <span style="display: flex; margin-top: 30px"
          ><h6>Enable this driver for ELDs</h6>
          <vs-checkbox v-model="enable_eld"></vs-checkbox
        ></span> -->
        <!-- <span style="display: flex; margin-top: 30px"
          ><h6>Enable this driver for E-Log</h6>
          <vs-checkbox v-model="enable_elog"></vs-checkbox
        ></span> -->
        <div class="grid grid-cols-2">
          <span style="display: flex; width: 100%; margin-top: 30px"
            ><h6>Allow Personal Conveyance</h6>
            <vs-checkbox v-model="allow_personal_c"></vs-checkbox
          ></span>
          <span style="display: flex; width: 100%; margin-top: 30px"
            ><h6>Allow Yard Move</h6>
            <vs-checkbox v-model="allow_yard"></vs-checkbox
          ></span>
          <span style="display: flex; width: 100%; margin-top: 30px"
            ><h6>Enable SSB</h6>
            <vs-checkbox v-model="enable_ssb"></vs-checkbox
          ></span>
          <span style="display: flex; width: 100%; margin-top: 30px"
            ><h6>Enable ShortHaul</h6>
            <vs-checkbox v-model="enable_short_haul"></vs-checkbox
          ></span>
          <span style="display: flex; width: 100%; margin-top: 30px"
            ><h6>Adverse Driving Conditions</h6>
            <vs-checkbox v-model="adverse_driving_conditions"></vs-checkbox
          ></span>
          <span style="display: flex; width: 100%; margin-top: 30px"
            ><h6>Disable Correction</h6>
            <vs-checkbox v-model="disable_correction"></vs-checkbox
          ></span>
        </div>
      </div>
    </component>
    <div
      class="flex flex-wrap items-center p-6"
      style="height: auto !important"
      slot="footer"
    >
      <vs-button class="mr-6" @click="submitData">Submit</vs-button>
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import GooglePlacesAutocomplete from "./GooglePlacesAutocomplate.vue";
export default {
  name: "DriverForm",
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    GooglePlacesAutocomplete,
  },
  data() {
    return {
      email: "",
      aviable: [],
      driverId: "",
      FirstName: "",
      LastName: "",
      UserName: "",
      password: null,
      Phone: "",
      licence: "",
      tadress: "",
      ttime: "",
      Province: "",
      codriver: "",
      coDrivers: [],
      vehicleid: null,
      TrailerNo: null,
      Notes: "",
      enable_eld: false,
      enable_elog: false,
      allow_yard: false,
      allow_personal_c: false,
      enable_ssb: false,
      enable_short_haul: false,
      adverse_driving_conditions: false,
      disable_correction: false,
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      color: "",
      licence1: [
        { text: "AK", value: "AK" },
        { text: "AL", value: "AL" },
        { text: "AR", value: "AR" },
        { text: "AZ", value: "AZ" },
        { text: "CA", value: "CA" },
        { text: "CO", value: "CO" },
        { text: "CT", value: "CT" },
        { text: "DE", value: "DE" },
        { text: "DC", value: "DC" },
        { text: "FL", value: "FL" },
        { text: "GA", value: "GA" },
        { text: "HI", value: "HI" },
        { text: "IA", value: "IA" },
        { text: "ID", value: "IL" },
        { text: "IN", value: "IN" },
        { text: "KS", value: "KS" },
        { text: "KY", value: "KY" },
        { text: "LA", value: "LA" },
        { text: "MA", value: "MA" },
        { text: "MD", value: "MD" },
        { text: "ME", value: "ME" },
        { text: "MI", value: "MI" },
        { text: "MN", value: "MO" },
        { text: "MS", value: "MS" },
        { text: "MT", value: "MT" },
        { text: "NC", value: "NC" },
        { text: "ND", value: "ND" },
        { text: "NE", value: "NE" },
        { text: "NH", value: "NH" },
        { text: "NJ", value: "NJ" },
        { text: "NM", value: "NM" },
        { text: "NV", value: "NV" },
        { text: "NY", value: "NY" },
        { text: "OH", value: "OH" },
        { text: "OK", value: "OK" },
        { text: "OR", value: "OR" },
        { text: "PA", value: "PA" },
        { text: "RI", value: "RI" },
        { text: "SC", value: "SC" },
        { text: "SD", value: "SD" },
        { text: "TN", value: "TN" },
        { text: "TX", value: "TX" },
        { text: "UT", value: "UT" },
        { text: "VA", value: "VA" },
        { text: "VT", value: "VT" },
        { text: "WA", value: "WA" },
        { text: "WI", value: "WI" },
        { text: "WV", value: "WV" },
        { text: "WY", value: "WY" },
      ],
      timeOptions: [
        { text: "Alaskan Standard Time", value: "alaska" },
        { text: "Central Standard Time", value: "central" },
        { text: "Eastern Standard Time", value: "eastern" },
        { text: "Hawaiian Standard Time", value: "hawaiian" },
        { text: "Mountain Daylight Time", value: "mountaind" },
        { text: "Mountain Standard Time", value: "mountains" },
        { text: "Pacific Standard Time", value: "pacific" },
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      colors: [
        {
          text: "Blue",
          value: "#0000FF",
        },
      ],
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        // console.log(this.data, "data");
        const {
          id,
          name,
          last_name,
          username,
          phone,
          driver_license_number,
          home_terminal_address,
          home_terminal_time_zone,
          co_driver,
          vehicle_id,
          notes_driver,
          trail_number,
          email,
          enable_dr_eld,
          enable_dr_elog,
          allow_yard,
          allow_personal_c,
          dr_li_issue_state,
          enable_ssb,
          enable_short_haul,
          adverse_driving_conditions,
          disable_correction,
          address1,
          address2,
          city,
          state,
          zip,
          color,
        } = JSON.parse(JSON.stringify(this.data));
        (this.driverId = id),
          (this.email = email),
          (this.FirstName = name),
          (this.LastName = last_name),
          (this.UserName = username),
          (this.Phone = phone),
          (this.licence = driver_license_number),
          (this.ttime = home_terminal_time_zone),
          // (this.tadress = home_terminal_address),
          (this.Province = dr_li_issue_state),
          (this.codriver = co_driver),
          (this.vehicleid = vehicle_id),
          (this.TrailerNo = trail_number.toString()),
          (this.Notes = notes_driver),
          (this.enable_eld = enable_dr_eld),
          (this.enable_elog = enable_dr_elog),
          (this.allow_yard = allow_yard),
          (this.allow_personal_c = allow_personal_c);
        (this.enable_ssb = enable_ssb),
          (this.enable_short_haul = enable_short_haul),
          (this.adverse_driving_conditions = adverse_driving_conditions),
          (this.disable_correction = disable_correction);
        (this.address1 = address1),
          (this.address2 = address2),
          (this.city = city),
          (this.state = state),
          (this.zip = zip),
          (this.color = color);
        this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    activeUserInfo() {
      return this.$store.state.company.company;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    initValues() {
      if (this.data.id) return;
      (this.driverId = ""),
        (this.email = ""),
        (this.FirstName = ""),
        (this.LastName = ""),
        (this.UserName = ""),
        (this.password = ""),
        (this.Phone = ""),
        (this.licence = ""),
        (this.ttime = ""),
        (this.Province = ""),
        (this.codriver = ""),
        (this.vehicleid = null),
        (this.TrailerNo = ""),
        (this.Notes = ""),
        (this.enable_eld = false),
        (this.enable_elog = false),
        (this.allow_yard = false),
        (this.allow_personal_c = false);
      (this.enable_ssb = false),
        (this.enable_short_haul = false),
        (this.adverse_driving_conditions = false),
        (this.disable_correction = false);
      (this.address1 = ""),
        (this.address2 = ""),
        (this.city = ""),
        (this.state = ""),
        (this.zip = "");
      this.color = "";
    },
    submitData() {
      let arr = [];
      arr[0] = parseInt(this.TrailerNo);
      // console.log(arr);
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(typeof this.ttime === "object", "ttime", this.ttime);
          this.$vs.loading();
          const obj = {
            id: this.driverId,
            name: this.FirstName,
            email: this.email,
            last_name: this.LastName,
            username: this.UserName,
            password: this.password,
            phone: this.Phone,
            driver_license_number: this.licence,
            home_terminal_address: this.tadress,
            home_terminal_time_zone:
              typeof this.ttime === "object" ? this.ttime.value : this.ttime,
            co_driver:
              this.codriver === null
                ? null
                : typeof this.codriver == "object"
                ? this.codriver.id
                : this.codriver,
            vehicle_id:
              typeof this.vehicleid === "object"
                ? this.vehicleid.id
                : this.vehicleid,
            trail_number: "undefined",
            notes_driver: this.Notes,
            enable_dr_eld: this.enable_eld,
            enable_dr_elog: this.enable_elog,
            dr_li_issue_state:
              typeof this.Province === "object"
                ? this.Province.value
                : this.Province,
            allow_yard: this.allow_yard,
            allow_personal_c: this.allow_personal_c,
            enable_ssb: this.enable_ssb,
            enable_short_haul: this.enable_short_haul,
            adverse_driving_conditions: this.adverse_driving_conditions,
            disable_correction: this.disable_correction,
            address1: this.address1,
            address2: this.address2,
            city: this.city,
            state: this.state,
            zip: this.zip,
            color:
              typeof this.color == "object" ? this.color.value : this.color,
          };
          if (Object.entries(this.data).length === 0) {
            delete obj.id;
            this.$store
              .dispatch("driver/addItem", obj)
              .then((res) => {
                // console.log(res);
                this.$vs.loading.close();
                this.$vs.notify({
                  title: "Ok",
                  text: "Created",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((error) => {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: "Ok",
                  text: error.response.data.data.cause,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              });
          } else {
            obj.trail_number = undefined;
            this.$store
              .dispatch("driver/updateItem", obj)
              .then((res) => {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: "Ok",
                  text: "Updated",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((error) => {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: "Error",
                  text: error,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              });
          }
        }
      });
    },
    
    handlePlaceSelected(place) {
      place.address_components.forEach((component) => {
        if (component.types.includes("locality")) {
          this.city = component.long_name;
        }
        if (component.types.includes("postal_code")) {
          this.zip = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          this.state = component.long_name;
        }
      });

      this.address1 = place.formatted_address;
    },
  },
  created() {
    this.$store.dispatch("driver/fetchDataListItems").then((response) => {
      let index = response.data.data.available_vehicle_id.reduce(
        (acc, cur) => Object.assign(acc, cur),
        {}
      );
      for (const iterator in index) {
        // console.log(iterator);
        this.aviable.push({ text: index[iterator], id: iterator });
      }
      this.coDrivers = response.data.data.drivers;
      // console.log(this.aviable);
    });
  },
  async mounted() {
    await this.$store.dispatch("company/fetchDataListItems");
    this.tadress = this.activeUserInfo.address;
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 40%;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
